module.exports = __webpack_public_path__ + "img/yoomoney.f33b9680.svg";